'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { ProgressStepperStepContext } from './context/progress-stepper-step.context';
import { ProgressStepperStepLabel } from './progress-stepper-step-label';
import { progressStepperCurrentLabelStyles } from './styles/progress-stepper-current-label.styles';
import type { ProgressStepperCurrentLabelPropsInterface } from './types/progress-stepper-current-label.types';

const STATIC_CONTEXT_VALUE = { tone: 'none', interactive: false, active: true } as const;

/**
 * ProgressStepper.CurrentLabel
 *
 * @extends ProgressStepperStepLabel
 * @since 8.57.0
 */
export const ProgressStepperCurrentLabel = forwardRef<
  HTMLSpanElement,
  ProgressStepperCurrentLabelPropsInterface
>((props: ProgressStepperCurrentLabelPropsInterface, forwardedRef) => {
  const { className, css: cssProp, ...rest } = props;

  const styles = css(progressStepperCurrentLabelStyles, cssProp);

  return (
    <ProgressStepperStepContext.Provider value={STATIC_CONTEXT_VALUE}>
      <ProgressStepperStepLabel
        aria-hidden
        className={cx('c11n', styles, className)}
        data-c11n-component="ProgressStepper.CurrentLabel"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      />
    </ProgressStepperStepContext.Provider>
  );
});

ProgressStepperCurrentLabel.displayName = 'ProgressStepper.CurrentLabel';
